// extracted by mini-css-extract-plugin
export default {"container":"individual-entrepreneur_container__5ZWMh","wrapper-content":"individual-entrepreneur_wrapper-content__kNDJU","title":"individual-entrepreneur_title__acnsY"};